const multiplayerQueryKeys = {
  session: (request) => [
    "multiplayer-session-v2",
    request?.resourceId ? request : null
  ]
};

export { multiplayerQueryKeys };
//# sourceMappingURL=multiplayerQueryKeys.js.map
